import React, { useState } from "react";

export default function DropdownField({
  label,
  options = [],
  value,
  onChange,
  required,
  placeholder = "Select option",
  displayValue,
  className = "",        // <-- Missing earlier, now added
}) {
  const [open, setOpen] = useState(false);

  const selectedLabel =
  displayValue ||
  options.find((opt) => opt.value === value)?.label ||
  placeholder;


  return (
    <div  style={{ position: "relative" }}>
      {label && (
        <label className="mb-2 fs-lg fw-b">
          {label} {required && <span className="text-danger">*</span>}
        </label>
      )}

      {/* Select Box */}
      <div
        className={`form-select ${className}`}
        style={{ cursor: "pointer",padding:"8px" }}
        onClick={() => setOpen(!open)}
      >
        {selectedLabel}
      </div>

      {/* Dropdown List */}
      {open && (
        <ul
          className="list-group position-absolute w-100 shadow-sm rounded-3 mt-1 bg-white"
          style={{ zIndex: 999, maxHeight: 200, overflowY: "auto" }}
        >
          {options.map((opt) => (
            <li
              key={opt.value}
              className="list-group-item border-0"
              style={{ cursor: "pointer" }}
              onClick={() => {
                onChange({ target: { value: opt.value } });
                setOpen(false);
              }}
              onMouseEnter={(e) => {
                e.target.style.background = "#356c89"; // your theme color
                e.target.style.color = "#fff";
              }}
              onMouseLeave={(e) => {
                e.target.style.background = "#fff";
                e.target.style.color = "#000";
              }}
            >
              {opt.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
